import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'have_workers_been_denied_access_their_original_personal'

export const dataPointDefinition = {
  retracedId: 'have_workers_been_denied_access_their_original_personal',
  name: 'Have workers been denied access to any of their original personal documents (such as birth certificates, passports, work',
  description:
    "Ordinarily, workers should keep their original personal documents themselves. In some cases, employers may be allowed to hold on to workers' documents, for example, if necessary to ensure that the documents are secure. However, workers should freely and knowingly consent to this, and they should be ",
  meta: {
    slcpMeta: {
      key: 'fl-14--1',
      number: 'WT-FOR-11',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fl-14--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27070,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
